import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6ffd7a8b = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _72c6acc3 = () => interopDefault(import('../pages/chat/index.vue' /* webpackChunkName: "pages/chat/index" */))
const _7627cf4e = () => interopDefault(import('../pages/cl_payments/index.vue' /* webpackChunkName: "pages/cl_payments/index" */))
const _1423f5b5 = () => interopDefault(import('../pages/client_trends/index.vue' /* webpackChunkName: "pages/client_trends/index" */))
const _229cfbf6 = () => interopDefault(import('../pages/contents/index.vue' /* webpackChunkName: "pages/contents/index" */))
const _5c6621fd = () => interopDefault(import('../pages/contract/index.vue' /* webpackChunkName: "pages/contract/index" */))
const _54b83be6 = () => interopDefault(import('../pages/docs/index.vue' /* webpackChunkName: "pages/docs/index" */))
const _255d8706 = () => interopDefault(import('../pages/goal_terms/index.vue' /* webpackChunkName: "pages/goal_terms/index" */))
const _ad8d1d74 = () => interopDefault(import('../pages/lessons/index.vue' /* webpackChunkName: "pages/lessons/index" */))
const _f2a8a4da = () => interopDefault(import('../pages/lifelog/index.vue' /* webpackChunkName: "pages/lifelog/index" */))
const _06969342 = () => interopDefault(import('../pages/line/index.vue' /* webpackChunkName: "pages/line/index" */))
const _bc001e18 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _3f19445c = () => interopDefault(import('../pages/ranks/index.vue' /* webpackChunkName: "pages/ranks/index" */))
const _17a81687 = () => interopDefault(import('../pages/reserve/index.vue' /* webpackChunkName: "pages/reserve/index" */))
const _6c67d92e = () => interopDefault(import('../pages/training_events/index.vue' /* webpackChunkName: "pages/training_events/index" */))
const _3d36b94a = () => interopDefault(import('../pages/version_up.vue' /* webpackChunkName: "pages/version_up" */))
const _3af33a62 = () => interopDefault(import('../pages/health/consent.vue' /* webpackChunkName: "pages/health/consent" */))
const _19208884 = () => interopDefault(import('../pages/health/settings.vue' /* webpackChunkName: "pages/health/settings" */))
const _31c5d740 = () => interopDefault(import('../pages/lifelog/detail.vue' /* webpackChunkName: "pages/lifelog/detail" */))
const _7f8c4bad = () => interopDefault(import('../pages/lifelog/food.vue' /* webpackChunkName: "pages/lifelog/food" */))
const _613b006c = () => interopDefault(import('../pages/line/unlock/index.vue' /* webpackChunkName: "pages/line/unlock/index" */))
const _6774a9ce = () => interopDefault(import('../pages/login/deputy.vue' /* webpackChunkName: "pages/login/deputy" */))
const _aede8b62 = () => interopDefault(import('../pages/login/forget_id.vue' /* webpackChunkName: "pages/login/forget_id" */))
const _710d2d49 = () => interopDefault(import('../pages/login/re_password.vue' /* webpackChunkName: "pages/login/re_password" */))
const _49a93c4f = () => interopDefault(import('../pages/reserve/event.vue' /* webpackChunkName: "pages/reserve/event" */))
const _72a19353 = () => interopDefault(import('../pages/reserve/lesson.vue' /* webpackChunkName: "pages/reserve/lesson" */))
const _5700f758 = () => interopDefault(import('../pages/settings/alert.vue' /* webpackChunkName: "pages/settings/alert" */))
const _e66cd66a = () => interopDefault(import('../pages/settings/alerts.vue' /* webpackChunkName: "pages/settings/alerts" */))
const _58f8c078 = () => interopDefault(import('../pages/settings/card.vue' /* webpackChunkName: "pages/settings/card" */))
const _a47b1f62 = () => interopDefault(import('../pages/settings/course.vue' /* webpackChunkName: "pages/settings/course" */))
const _2c8e9998 = () => interopDefault(import('../pages/settings/email.vue' /* webpackChunkName: "pages/settings/email" */))
const _2f1d5f8a = () => interopDefault(import('../pages/settings/goal/index.vue' /* webpackChunkName: "pages/settings/goal/index" */))
const _558bb3cf = () => interopDefault(import('../pages/settings/password.vue' /* webpackChunkName: "pages/settings/password" */))
const _1cb64025 = () => interopDefault(import('../pages/settings/profile.vue' /* webpackChunkName: "pages/settings/profile" */))
const _60ddd75e = () => interopDefault(import('../pages/settings/shared_docs.vue' /* webpackChunkName: "pages/settings/shared_docs" */))
const _a102249c = () => interopDefault(import('../pages/settings/goal/edit_pdc.vue' /* webpackChunkName: "pages/settings/goal/edit_pdc" */))
const _b6e0aafc = () => interopDefault(import('../pages/settings/goal/edit.vue' /* webpackChunkName: "pages/settings/goal/edit" */))
const _2044b01a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _008eddf8 = () => interopDefault(import('../pages/bodyscans/_filter.vue' /* webpackChunkName: "pages/bodyscans/_filter" */))
const _73bd92a4 = () => interopDefault(import('../pages/contents/_uid.vue' /* webpackChunkName: "pages/contents/_uid" */))
const _2b23e664 = () => interopDefault(import('../pages/payment/_token/index.vue' /* webpackChunkName: "pages/payment/_token/index" */))
const _de02a65a = () => interopDefault(import('../pages/points/_filter.vue' /* webpackChunkName: "pages/points/_filter" */))
const _e4b5ec28 = () => interopDefault(import('../pages/reserve/_uid.vue' /* webpackChunkName: "pages/reserve/_uid" */))
const _ef474518 = () => interopDefault(import('../pages/ticket_sets/_filter.vue' /* webpackChunkName: "pages/ticket_sets/_filter" */))
const _656a47e2 = () => interopDefault(import('../pages/trial/_campaign_uid.vue' /* webpackChunkName: "pages/trial/_campaign_uid" */))
const _992a2b26 = () => interopDefault(import('../pages/payment/_token/complete.vue' /* webpackChunkName: "pages/payment/_token/complete" */))
const _74a341ec = () => interopDefault(import('../pages/line/_.vue' /* webpackChunkName: "pages/line/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cart/",
    component: _6ffd7a8b,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/chat/",
    component: _72c6acc3,
    pathToRegexpOptions: {"strict":true},
    name: "chat"
  }, {
    path: "/cl_payments/",
    component: _7627cf4e,
    pathToRegexpOptions: {"strict":true},
    name: "cl_payments"
  }, {
    path: "/client_trends/",
    component: _1423f5b5,
    pathToRegexpOptions: {"strict":true},
    name: "client_trends"
  }, {
    path: "/contents/",
    component: _229cfbf6,
    pathToRegexpOptions: {"strict":true},
    name: "contents"
  }, {
    path: "/contract/",
    component: _5c6621fd,
    pathToRegexpOptions: {"strict":true},
    name: "contract"
  }, {
    path: "/docs/",
    component: _54b83be6,
    pathToRegexpOptions: {"strict":true},
    name: "docs"
  }, {
    path: "/goal_terms/",
    component: _255d8706,
    pathToRegexpOptions: {"strict":true},
    name: "goal_terms"
  }, {
    path: "/lessons/",
    component: _ad8d1d74,
    pathToRegexpOptions: {"strict":true},
    name: "lessons"
  }, {
    path: "/lifelog/",
    component: _f2a8a4da,
    pathToRegexpOptions: {"strict":true},
    name: "lifelog"
  }, {
    path: "/line/",
    component: _06969342,
    pathToRegexpOptions: {"strict":true},
    name: "line"
  }, {
    path: "/login/",
    component: _bc001e18,
    pathToRegexpOptions: {"strict":true},
    name: "login"
  }, {
    path: "/ranks/",
    component: _3f19445c,
    pathToRegexpOptions: {"strict":true},
    name: "ranks"
  }, {
    path: "/reserve/",
    component: _17a81687,
    pathToRegexpOptions: {"strict":true},
    name: "reserve"
  }, {
    path: "/training_events/",
    component: _6c67d92e,
    pathToRegexpOptions: {"strict":true},
    name: "training_events"
  }, {
    path: "/version_up/",
    component: _3d36b94a,
    pathToRegexpOptions: {"strict":true},
    name: "version_up"
  }, {
    path: "/health/consent/",
    component: _3af33a62,
    pathToRegexpOptions: {"strict":true},
    name: "health-consent"
  }, {
    path: "/health/settings/",
    component: _19208884,
    pathToRegexpOptions: {"strict":true},
    name: "health-settings"
  }, {
    path: "/lifelog/detail/",
    component: _31c5d740,
    pathToRegexpOptions: {"strict":true},
    name: "lifelog-detail"
  }, {
    path: "/lifelog/food/",
    component: _7f8c4bad,
    pathToRegexpOptions: {"strict":true},
    name: "lifelog-food"
  }, {
    path: "/line/unlock/",
    component: _613b006c,
    pathToRegexpOptions: {"strict":true},
    name: "line-unlock"
  }, {
    path: "/login/deputy/",
    component: _6774a9ce,
    pathToRegexpOptions: {"strict":true},
    name: "login-deputy"
  }, {
    path: "/login/forget_id/",
    component: _aede8b62,
    pathToRegexpOptions: {"strict":true},
    name: "login-forget_id"
  }, {
    path: "/login/re_password/",
    component: _710d2d49,
    pathToRegexpOptions: {"strict":true},
    name: "login-re_password"
  }, {
    path: "/reserve/event/",
    component: _49a93c4f,
    pathToRegexpOptions: {"strict":true},
    name: "reserve-event"
  }, {
    path: "/reserve/lesson/",
    component: _72a19353,
    pathToRegexpOptions: {"strict":true},
    name: "reserve-lesson"
  }, {
    path: "/settings/alert/",
    component: _5700f758,
    pathToRegexpOptions: {"strict":true},
    name: "settings-alert"
  }, {
    path: "/settings/alerts/",
    component: _e66cd66a,
    pathToRegexpOptions: {"strict":true},
    name: "settings-alerts"
  }, {
    path: "/settings/card/",
    component: _58f8c078,
    pathToRegexpOptions: {"strict":true},
    name: "settings-card"
  }, {
    path: "/settings/course/",
    component: _a47b1f62,
    pathToRegexpOptions: {"strict":true},
    name: "settings-course"
  }, {
    path: "/settings/email/",
    component: _2c8e9998,
    pathToRegexpOptions: {"strict":true},
    name: "settings-email"
  }, {
    path: "/settings/goal/",
    component: _2f1d5f8a,
    pathToRegexpOptions: {"strict":true},
    name: "settings-goal"
  }, {
    path: "/settings/password/",
    component: _558bb3cf,
    pathToRegexpOptions: {"strict":true},
    name: "settings-password"
  }, {
    path: "/settings/profile/",
    component: _1cb64025,
    pathToRegexpOptions: {"strict":true},
    name: "settings-profile"
  }, {
    path: "/settings/shared_docs/",
    component: _60ddd75e,
    pathToRegexpOptions: {"strict":true},
    name: "settings-shared_docs"
  }, {
    path: "/settings/goal/edit_pdc/",
    component: _a102249c,
    pathToRegexpOptions: {"strict":true},
    name: "settings-goal-edit_pdc"
  }, {
    path: "/settings/goal/edit/",
    component: _b6e0aafc,
    pathToRegexpOptions: {"strict":true},
    name: "settings-goal-edit"
  }, {
    path: "/",
    component: _2044b01a,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/bodyscans/:filter?/",
    component: _008eddf8,
    pathToRegexpOptions: {"strict":true},
    name: "bodyscans-filter"
  }, {
    path: "/contents/:uid/",
    component: _73bd92a4,
    pathToRegexpOptions: {"strict":true},
    name: "contents-uid"
  }, {
    path: "/payment/:token/",
    component: _2b23e664,
    pathToRegexpOptions: {"strict":true},
    name: "payment-token"
  }, {
    path: "/points/:filter?/",
    component: _de02a65a,
    pathToRegexpOptions: {"strict":true},
    name: "points-filter"
  }, {
    path: "/reserve/:uid/",
    component: _e4b5ec28,
    pathToRegexpOptions: {"strict":true},
    name: "reserve-uid"
  }, {
    path: "/ticket_sets/:filter?/",
    component: _ef474518,
    pathToRegexpOptions: {"strict":true},
    name: "ticket_sets-filter"
  }, {
    path: "/trial/:campaign_uid?/",
    component: _656a47e2,
    pathToRegexpOptions: {"strict":true},
    name: "trial-campaign_uid"
  }, {
    path: "/payment/:token?/complete/",
    component: _992a2b26,
    pathToRegexpOptions: {"strict":true},
    name: "payment-token-complete"
  }, {
    path: "/line/*",
    component: _74a341ec,
    pathToRegexpOptions: {"strict":true},
    name: "line-all"
  }, {
    path: "/t/*",
    redirect: "/trial/*"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
